import { FETCH_IMPRESSION_STATS, loadImpressionStats } from '../Actions/ImpressionStats'
import gql from 'graphql-tag'
import { from, EMPTY } from 'rxjs'
import { filter, mergeMap, map, catchError } from 'rxjs/operators'
import client from '../ApolloClient'

const impressionStatsQuery = gql`
  query GetImpressionStatsAggregate($accountId: ID!, $startDate: DateTime!, $endDate: DateTime!, $appType: String!, $appProfileIds: [ID!]) {
    impressionStatsAggregate(accountId: $accountId, startDate: $startDate, endDate: $endDate, appType: $appType, appProfileIds: $appProfileIds) {
      totalImpressions
      uniqueImpressions
      totalReactions
      totalContentsCreated
    }
  }
`

/**
 * impressionStatsEpic
 * @desc Epic for fetching impression stats
 * @param {Observable} action$ stream of actions
 * @return {Observable} stream of actions
 */
export const impressionStatsEpic = (action$) =>
  action$.pipe(
    filter((action) => action.type === FETCH_IMPRESSION_STATS),
    mergeMap((action) => {
      const { accountId, startDate, endDate, appType, appProfileIds } = action.query
      return from(
        client.query({
          query: impressionStatsQuery,
          variables: { accountId, startDate, endDate, appType, appProfileIds }
        })
      ).pipe(
        map((response) => loadImpressionStats(response.data.impressionStatsAggregate)),
        catchError((error) => {
          console.error('Error fetching impression stats:', error)
          return EMPTY
        })
      )
    })
  )
